import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [subMsg, setSubMsg] = useState('');

  const handleSubscribe = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();

    if (honeypotVal) {
      setSubStatus('success');
      setSubMsg('订阅成功！感谢您的关注 🍉');
      setEmail('');
      return;
    }

    if (!email.trim()) {
      setSubStatus('error');
      setSubMsg('请输入有效的邮箱地址');
      return;
    }

    try {
      const data = new URLSearchParams();
      data.append('email', email.trim());

      const response = await fetch('http://91yingba.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setSubStatus('success');
        setSubMsg('订阅成功！每日最新爆料将发送到您的邮箱 🍉');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '订阅失败，请稍后重试';
        setSubStatus('error');
        setSubMsg(serverMsg);
      }
    } catch {
      setSubStatus('error');
      setSubMsg('网络错误，请稍后重试');
    }
  };

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-9 h-9 flex items-center justify-center">
                <span className="text-3xl">🍉</span>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                五一吃瓜网
              </span>
            </Link>

            <form
              onSubmit={handleSubscribe}
              className="flex items-center gap-2 mb-5"
             
            >
              <div className="flex-1 max-w-xs">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅每日爆料"
                  className="w-full px-4 py-2.5 text-sm bg-primary-800/50 border border-primary-700/50 rounded-full text-background-50 placeholder:text-primary-300/60 focus:outline-none focus:border-accent-400 transition-colors"
                  required
                />
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 hover:bg-accent-600 transition-colors flex-shrink-0 cursor-pointer"
                aria-label="订阅"
              >
                <i className="ri-notification-3-line text-background-50 text-lg"></i>
              </button>
            </form>

            {subStatus !== 'idle' && (
              <p className={`text-xs mb-3 ${subStatus === 'success' ? 'text-accent-400' : 'text-secondary-400'}`}>
                {subMsg}
              </p>
            )}

            <p className="text-primary-200/80 text-sm leading-relaxed mb-3">
              每日更新网红黑料与网络热门事件
            </p>
            <p className="text-primary-300/60 text-sm leading-relaxed">
              不错过任何一个瓜，从五一吃瓜网开始
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                热门分类
              </h4>
              <ul className="flex flex-col gap-2.5">
                {categories.slice(0, 3).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-primary-200/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                更多分类
              </h4>
              <ul className="flex flex-col gap-2.5">
                {categories.slice(3).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-primary-200/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                关于我们
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-primary-200/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-primary-200/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    联系我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-primary-200/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    投稿爆料
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-700/30">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-primary-300/60">
            &copy; 2026 五一吃瓜网. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="http://91yingba.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-lg border border-primary-600/40 text-primary-300/60 hover:text-background-50 hover:border-primary-400 transition-colors cursor-pointer"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a
              href="http://91yingba.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-lg border border-primary-600/40 text-primary-300/60 hover:text-background-50 hover:border-primary-400 transition-colors cursor-pointer"
              aria-label="知乎"
            >
              <i className="ri-zhihu-line text-sm"></i>
            </a>
            <a
              href="http://91yingba.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-lg border border-primary-600/40 text-primary-300/60 hover:text-background-50 hover:border-primary-400 transition-colors cursor-pointer"
              aria-label="微信"
            >
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a
              href="http://91yingba.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-lg border border-primary-600/40 text-primary-300/60 hover:text-background-50 hover:border-primary-400 transition-colors cursor-pointer"
              aria-label="抖音"
            >
              <i className="ri-tiktok-line text-sm"></i>
            </a>
          </div>
          <div className="flex items-center gap-4">
            <Link
              to="/about"
              className="text-xs text-primary-300/60 hover:text-background-50 transition-colors cursor-pointer"
            >
              隐私政策
            </Link>
            <Link
              to="/about"
              className="text-xs text-primary-300/60 hover:text-background-50 transition-colors cursor-pointer"
            >
              用户协议
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}